
<template>
  <div class="listcontainer">
    <div class="cardcontainer">
      <draggable ref="draggableelement" v-bind="dragOptions" class="fab-menu-inner" filter=".ignore-elements" tag="div" :group="{ name: 'description', put: true }" @add="add" @start="dragStart" @end="dragEnd" @update="dragUpdated">
        <slot></slot>
        <div class="card mx-0 px-0 skin shadow-1 rounded" :key="el.id" v-for="el in cards" :id="el.id">
          <div class="card-header" v-if="el.header && el.header != null" v-html="el.header">Header</div>
          <div class="card-body">
            <h5 class="card-title" v-if="el.title && el.title != null" v-html="el.title">Primary card title</h5>
            <p class="card-text" v-if="el.text && el.text != null" v-html="el.text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            <div class="error" v-if="!el.id || el.id == null">Error: id-attribute is missing</div>
          </div>
        </div>
      </draggable>
    </div>
    <div>{{message}}</div>
  </div>
</template>

<script>

  import draggable from "vuedraggable";

	export default {
    name: 'card-list',
    components: {
      draggable
    },
    data() {
      return {
        cards: [],
        idGlobal: 1,
        message: "init",
      }
    },
    props: 
      {
        oncardschange: {
          required: false,
          type: String,
          default: null
        },
      }
    ,
    methods: {
      getId() {
        return this._uid;
      },
      setCards(cards) {
        this.cards = cards;
      },
      dragStart() {
        
      },
      add(event) {
        this.doChange(event, "add")
      },

      dragEnd(event) {
       
      },

      dragUpdated() {
        this.doChange(event, "update")
      },

      cloneElement({ }) {
        return {

        };
      },

      doChange(event, source) {
        this.message = source
        var changedElementId = null;
        if (event.item && event.item != null)
          changedElementId = event.item.id;
        else if (event.dragged && event.dragged != null)
          changedElementId = event.dragged.id;
        var targetIds = [];
        var draggableContainer = this.$refs.draggableelement.$el;
        for (var i = 0; i < draggableContainer.childNodes.length; i++) {
          var childNode = draggableContainer.childNodes[i];
          if (childNode.id && childNode.id != null && childNode.id != "")
            targetIds.push(childNode.id);
        }
        var changeEvent = {
          targetElements: targetIds,
          target: this.$el.id,
          added: changedElementId,
          source: source,
        };
        if (this.oncardschange != null)
          eval(this.oncardschange + '(changeEvent);');
      }
    },
    created() {
      
    },
    mounted() {

    },
    computed: {
      dragOptions() {
        return {
          sort: true,
          disabled: false,
          ghostClass: "ghost",
          animation: 500,
        };
      },
    }
}
</script>
<style scoped>
 
</style>



// WEBPACK FOOTER //
// src/components/cards/card-list.vue